import React from "react"
import { Tag } from "antd"
import { CloseCircleOutlined } from "@ant-design/icons"
import PropTypes from "prop-types"
import styles from "./index.module.css"

/**
 * Themed tag for use as AntD Select's tagRender prop.
 * Accepts the same props AntD passes to tagRender: { label, value, closable, onClose }.
 * Usage: <Select tagRender={SelectTag} ... />
 */
export const SelectTag = ({ label, value, closable, onClose }) => (
  <Tag
    closable={closable}
    onClose={onClose}
    closeIcon={<CloseCircleOutlined />}
    className={`mr-xxs ${styles.selectedTag}`}
  >
    {label || value}
  </Tag>
)

SelectTag.propTypes = {
  label: PropTypes.node,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  closable: PropTypes.bool,
  onClose: PropTypes.func,
}
